import {
  AccredibleExpansionPanelComponent,
  ExpansionPanelTriggerConfig,
} from '@accredible-frontend-v2/new-components/expansion-panel';
import { CommonModule } from '@angular/common';
import { Component, computed, signal } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'dod-faq',
  standalone: true,
  imports: [CommonModule, AccredibleExpansionPanelComponent, TranslocoModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class DoDFaqComponent {
  private readonly faqIndexes = signal(Array.from({ length: 9 }, (_, i) => i + 1));

  protected readonly triggerConfigs = computed(() => {
    return this.faqIndexes().map(() => ({
      style: 'custom',
      width: 'full',
      expandGroup: 'faq',
    })) as ExpansionPanelTriggerConfig[];
  });
}
